import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  API,
  BookingDTO,
  CampaignWithPreviewDTO,
  CommercialDTO,
  CommercialFullDTO,
  CommercialWithPreviewDTO,
  TimeCullDTO,
  PlayerCullDTO,
  CullDTO,
  GeoCullDTO,
  MediumDTO,
  Pagination,
  ReportingFullDTO,
  RequirementFullDTO,
  TimingStatus,
  Order,
  ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order,
} from '../../../../services/api/api';
import { ErrorService } from '../../../../services/error.service';
import { ModalService } from '../../../../services/gui/modal/modal.service';
import { UtilService } from '../../../../services/util.service';
import { CampaignReportingService } from '../../../../services/campaign-reporting.service';
import { TranslateService } from '@ngx-translate/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { SbDateTime, SbLocalDateTime } from 'src/app/services/api/api-date-time';
import { TagService } from '../../../../services/tag.service';
import { CommercialWithPreviewReportingDTOAndTags } from '../../../../models/taggable.model';
import { DiscussionService } from '../../../../services/discussion.service';
import { BehaviorSubject, forkJoin, from, of, switchMap } from 'rxjs';
import { QueryParamService } from '../../../../services/lists/query-params';
import { ModalNavigationComponent } from '../../../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { ReportingModalComponent } from '../../../../components/standard-reporting/reporting-modal/reporting-modal.component';
import { ReportingService } from '../../../../services/reporting.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PermissionService } from '../../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BookingService } from '../../../../services/booking.service';
import { MsOptions, Mutable, OrderOption, SbBooleanToggleModel } from '../../../../services/global/global-interfaces';
import { FilterStorageService } from '../../../../services/filter-storage.service';
import { DateTime } from 'luxon';
import { DateTransformationService } from '../../../../services/transformation-helper/date-transformation.service';

export interface CommercialWithPreviewReportingDTOWithHoverAndTags extends CommercialWithPreviewReportingDTOAndTags {
  isHover?: boolean;
}

@Component({
  selector: 'sb-page-commercials-list',
  templateUrl: './commercials-list.component.html',
  styleUrls: ['./commercials-list.component.scss'],
  standalone: false,
})
export class CommercialsListComponent implements OnInit, ModalNavigationComponent {
  public readonly dateTransformation = inject(DateTransformationService);

  isInModalContext: boolean;

  commercials: CommercialWithPreviewReportingDTOWithHoverAndTags[];
  selectedCommercials: CommercialWithPreviewReportingDTOWithHoverAndTags[];
  selectedCampaign: CampaignWithPreviewDTO;
  selectedCompany: number;
  campaignId: number;
  loading: boolean;
  ghosts: any[];

  debounceTimer: ReturnType<typeof setTimeout> = null;
  pagination: BehaviorSubject<Pagination>;
  collectionSize: number;
  maxSize: number;
  resultCount: number;
  paginationString: string;

  timingPlanned: boolean;
  timingActive: boolean;
  timingEnded: boolean;
  timingUnknown: boolean;

  timingPlannedPrevious: boolean;
  timingActivePrevious: boolean;
  timingEndedPrevious: boolean;
  timingUnknownPrevious: boolean;

  orderMode: boolean;
  orderChanged: boolean;

  orderingAvailable: boolean;

  initialBooleans: SbBooleanToggleModel[];

  queryParamsParsed: boolean;
  exportState: boolean;
  form = new FormGroup({
    Title: new FormControl('', [Validators.required]),
  });
  reportName: string;
  reportTill: SbLocalDateTime;
  reportFrom: SbLocalDateTime;
  from: SbLocalDateTime;
  till: SbLocalDateTime;
  selectedPlayerCull: PlayerCullDTO;
  playerCulls: CullDTO[];
  selectedGeoCull: GeoCullDTO;
  geoCulls: CullDTO[];
  selectedTimeCull: TimeCullDTO;
  timeCulls: CullDTO[];
  selectedContentCulls: CullDTO[];
  contentCulls: CullDTO[];

  msPlayerCullOptions: MsOptions;
  msGeoCullOptions: MsOptions;
  msTimeCullOptions: MsOptions;
  msContentCullOptions: MsOptions;

  orderOption: OrderOption<string>;
  allOrderOptions: OrderOption<string>[] = [
    { value: 'OrderNum', direction: Order.asc, label: this.translate.instant('lang.globals.clientOrderNum') },
    { value: 'Title', direction: Order.asc, label: this.translate.instant('lang.globals.commercial') },
    { value: 'From', direction: Order.asc, label: this.translate.instant('lang.globals.fromTime') },
    { value: 'Till', direction: Order.asc, label: this.translate.instant('lang.globals.tillTime') },
    { value: 'Modified', direction: Order.asc, label: this.translate.instant('lang.globals.modifiedAt') },
    { value: 'Created', direction: Order.asc, label: this.translate.instant('lang.globals.createdAt') },
  ];

  constructor(
    private readonly api: API,
    private readonly activatedRoute: ActivatedRoute,
    public readonly errorHandler: ErrorService,
    public readonly modal: ModalService,
    public readonly util: UtilService,
    private readonly campaignsService: CampaignReportingService,
    public readonly translate: TranslateService,
    public readonly tagService: TagService,
    public readonly discussionService: DiscussionService,
    public readonly queryParamService: QueryParamService,
    private readonly modalNavigation: ModalNavigationService,
    private readonly reportingService: ReportingService,
    public readonly permissionService: PermissionService,
    private readonly destroyRef: DestroyRef,
    private readonly bookingService: BookingService,
    private readonly filterStorage: FilterStorageService
  ) {
    this.resetOrderOption();
    this.geoCulls = [];
    this.playerCulls = [];
    this.timeCulls = [];
    this.commercials = [];
    this.selectedCommercials = [];
    this.selectedCampaign = undefined;
    this.selectedCompany = undefined;
    this.campaignId = undefined;
    this.loading = true;
    this.ghosts = [];
    this.collectionSize = -1;
    this.maxSize = 99;
    this.resultCount = -1;
    this.pagination = new BehaviorSubject<Pagination>({
      page: 1,
      count: 99,
      pages: -1,
      resultcount: -1,
    });
    this.paginationString = '';
    this.timingPlannedPrevious = undefined;
    this.timingActivePrevious = undefined;
    this.timingEndedPrevious = undefined;
    this.timingUnknownPrevious = undefined;
    this.orderMode = false;
    this.orderChanged = false;
    this.orderingAvailable = false;
    this.queryParamsParsed = false;
    this.exportState = false;
    this.reportName = null;
    this.from = null;
    this.till = null;
    this.initBoolToggles();
  }

  get Title() {
    return this.form.get('Title');
  }

  get selectedContentCullIds(): number[] {
    return this.selectedContentCulls ? this.util.arrayToIdArray(this.selectedContentCulls) : [];
  }

  ngOnInit() {
    this.initPagination().then(() => {
      if (!this.queryParamsParsed) {
        this.filterStorage.fetch('COMMERCIAL');
        this.parseQueryParams().then(() => {
          this.queryParamsParsed = true;
          this.refreshBoolToggles();
          this.activatedRoute.params.subscribe(params => {
            if (this.isInModalContext) {
              this.selectedCommercials = this.modalNavigation.getCurrentNavigation()?.data?.selectedCommercials;
              this.campaignId = this.modalNavigation.getCurrentNavigation()?.data?.campaignId;
            } else {
              this.campaignId = +params.campaignID;
            }
            this.refreshFromServer().then();
          });
        });
      }
    });
  }

  initPagination(): Promise<void> {
    return new Promise(res => {
      this.pagination.subscribe((e: Pagination) => {
        this.collectionSize = e.resultcount;
        this.maxSize = e.count;
        this.resultCount = e.resultcount;
      });
      res();
    });
  }

  requestDebounced() {
    if (this.queryParamsParsed) {
      this.refreshQueryParams();
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer().then();
    }, 500);
  }

  refreshQueryParams() {
    if (this.isInModalContext) {
      return;
    }
    this.refreshBoolQueryParam('timingPlanned', this.timingPlanned);
    this.refreshBoolQueryParam('timingActive', this.timingActive);
    this.refreshBoolQueryParam('timingEnded', this.timingEnded);
    this.refreshBoolQueryParam('timingUnknown', this.timingUnknown);
  }

  refreshBoolQueryParam(name: string, value: boolean) {
    if (value === true || value === false) {
      this.queryParamService.setQueryParam(name, '' + value);
    } else {
      this.queryParamService.clearQueryParam(name);
    }
  }

  refreshFromServer(): Promise<any> {
    this.orderingAvailable = false;
    return new Promise(resolve => {
      this.loading = true;
      if (!this.commercials) {
        this.ghosts = new Array(2); // Mock Ghost items
      }

      this.api
        .ds_cm_Campaign_retrieveByIdFrontendEnhanced(this.campaignId)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: data => {
            if (this.permissionService.hasPermission(this.permissionService.Permission.tag_list)) {
              this.selectedCampaign = this.tagService.getAndAddTagEntities(this.tagService.TaggableDTO.Campaign, [data])[0];
            } else {
              this.selectedCampaign = data;
            }
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });

      this.api
        .ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced(
          this.campaignId,
          {
            timingStatus: this.getTimingSelections(),
            from: this.from,
            till: this.till,
            playerCullSet: this.selectedPlayerCull ? +this.selectedPlayerCull.id : null,
            geoCullSet: this.selectedGeoCull ? +this.selectedGeoCull.id : null,
            timeCullSet: this.selectedTimeCull ? +this.selectedTimeCull.id : null,
            contentCull: this.selectedContentCullIds,
            order: this.getOrder(),
          },
          this.pagination
        )
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: data => {
            this.refreshOrderingAvailable(data);
            this.commercials = data;
            if (this.permissionService.hasPermission(this.permissionService.Permission.ds_cm_reporting)) {
              this.commercials = this.campaignsService.getAndMergePulseChart(this.commercials);
            }
            if (this.permissionService.hasPermission(this.permissionService.Permission.tag_list)) {
              this.commercials = this.tagService.getAndAddTagEntities(this.tagService.TaggableDTO.Commercial, this.commercials);
            }
            this.paginationString = this.util.getPaginationString(
              1,
              this.maxSize,
              this.commercials?.length,
              this.resultCount,
              'commercials'
            );
            if (this.commercials) {
              this.ghosts = [];
              this.commercials = this.buildHoverable(this.commercials);
            }
            resolve(null);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
            resolve(null);
          },
        });
    });
  }

  getOrder(): { by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order; direction: Order } {
    // if no orderOption -> return default order
    if (!this.orderOption.value) {
      this.resetOrderOption();
      return {
        by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order.PRIORITY,
        direction: Order.asc,
      };
    }
    // if value equals column title
    switch (this.orderOption.value) {
      case 'Title':
        return { by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order.NAME, direction: this.orderOption.direction };
      case 'From':
        return {
          by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order.FROM_TIME,
          direction: this.orderOption.direction,
        };
      case 'Till':
        return {
          by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order.TILL_TIME,
          direction: this.orderOption.direction,
        };
      case 'Modified':
        return {
          by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order.MODIFIED_AT,
          direction: this.orderOption.direction,
        };
      case 'Created':
        return {
          by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order.CREATED_AT,
          direction: this.orderOption.direction,
        };
      case 'OrderNum':
      default:
        return {
          by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order.PRIORITY,
          direction: this.orderOption.direction,
        };
    }
  }

  resetOrderOption() {
    // reset to default ordering, copy object properties to avoid changing original default
    this.orderOption = this.allOrderOptions[0];
  }

  setToOrder(pValue: typeof this.orderOption.value) {
    if (!pValue) {
      // nothing is set fallback to default
      this.resetOrderOption();
    }
    if (this.orderOption.value === pValue) {
      if (this.orderOption.direction === Order.asc) {
        this.orderOption.direction = Order.desc;
      } else {
        this.orderOption.direction = Order.asc;
        this.resetOrderOption();
      }
    } else {
      this.orderOption.direction = Order.asc;
      this.orderOption = this.allOrderOptions.find(option => (option.value = pValue));
    }

    this.requestDebounced();
  }

  refreshOrderingAvailable(commercials: CommercialWithPreviewDTO[]): boolean {
    let c = 0;

    if (commercials && commercials.length > 1) {
      for (const commercial of commercials) {
        if (commercial.timingStatus === TimingStatus.Present || commercial.timingStatus === TimingStatus.Future) {
          c++;
          if (c > 1) {
            this.orderingAvailable = true;
            return true;
          }
        }
      }
    }
    this.orderingAvailable = false;
    return false;
  }

  getTimingSelections(): TimingStatus[] {
    const ret: TimingStatus[] = [];
    if (this.timingPlanned) {
      ret.push(TimingStatus.Future);
    }
    if (this.timingActive) {
      ret.push(TimingStatus.Present);
    }
    if (this.timingEnded) {
      ret.push(TimingStatus.Past);
    }
    if (this.timingUnknown) {
      ret.push(TimingStatus.Unknown);
    }
    return ret.length > 0 ? ret : null;
  }

  startOrdering() {
    if (!this.orderMode) {
      this.backupSelectors();
      this.timingActive = true;
      this.timingPlanned = true;
      this.timingEnded = false;
      this.timingUnknown = false;
      this.refreshFromServer().then(() => {
        this.orderMode = true;
      });
    }
  }

  checkModified(commercial: CommercialDTO): DateTime {
    return this.dateTransformation.laterDate(commercial.createdAt, commercial.modifiedAt);
  }

  applyOrdering() {
    if (this.orderMode) {
      this.restoreSelectors();
      this.api
        .ds_cm_Commercial_setPriority(this.commercials)
        .pipe(
          take(1),
          finalize(() => {
            // success and error case
            this.refreshFromServer().then(() => {
              this.orderMode = false;
            });
          })
        )
        .subscribe({
          next: () => {},
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  cancelOrdering() {
    if (this.orderMode) {
      this.restoreSelectors();
      this.refreshFromServer().then(() => {
        this.orderMode = false;
      });
    }
  }

  backupSelectors() {
    this.timingPlannedPrevious = this.timingPlanned;
    this.timingActivePrevious = this.timingActive;
    this.timingEndedPrevious = this.timingEnded;
    this.timingUnknownPrevious = this.timingUnknown;
  }

  restoreSelectors() {
    this.timingPlanned = this.timingPlannedPrevious;
    this.timingActive = this.timingActivePrevious;
    this.timingEnded = this.timingEndedPrevious;
    this.timingUnknown = this.timingUnknownPrevious;
  }

  drop($e: any) {
    moveItemInArray(this.commercials, $e.previousIndex, $e.currentIndex);
    this.orderChanged = true;
  }

  boolChange(t: string, $e: boolean) {
    switch (t) {
      case 'timingPlanned':
        this.timingPlanned = $e;
        break;
      case 'timingActive':
        this.timingActive = $e;
        break;
      case 'timingEnded':
        this.timingEnded = $e;
        break;
      case 'timingUnknown':
        this.timingUnknown = $e;
        break;
    }
    this.requestDebounced();
  }

  toggleCommercialEnabled(commercial: CommercialWithPreviewDTO, e: boolean) {
    let message: string;
    let title: string;

    if (e === false) {
      title = this.translate.instant('lang.commercials.disableCommercial');
      message = this.translate.instant('lang.commercials.disableCommercialQuestion');
    } else {
      title = this.translate.instant('lang.commercials.enableCommercial');
      message = this.translate.instant('lang.commercials.enableCommercialQuestion');
    }
    this.modal
      .confirm({
        title,
        message,
        yes: this.translate.instant('lang.globals.yes'),
        no: this.translate.instant('lang.globals.no'),
      })
      .then((result: boolean) => {
        if (result) {
          commercial.active = e;
          this.api
            .ds_cm_Commercial_editCommercial(commercial)
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: () => {},
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        } else {
          commercial.active = !e;
        }
      });
  }

  deleteCommercial(commercial: CommercialDTO) {
    this.modal
      .confirm({
        title: this.translate.instant('lang.commercials.deleteCommercial'),
        message: this.translate.instant('lang.commercials.deleteCommercialQuestion', { commercial: commercial.name }),
        yes: this.translate.instant('lang.globals.yes'),
        no: this.translate.instant('lang.globals.no'),
      })
      .then((result: boolean) => {
        if (result) {
          this.api
            .ds_cm_Commercial_deleteById(commercial.id)
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: () => {
                this.spliceCommercial(commercial);
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        }
      });
  }

  spliceCommercial(commercial: CommercialDTO) {
    const index = this.commercials.findIndex(x => x.id === commercial.id);
    if (index !== -1) {
      this.commercials.splice(index, 1);
    }
  }

  initBoolToggles() {
    this.timingPlanned = true;
    this.timingActive = true;
    this.timingEnded = true;
    this.timingUnknown = true;
    this.refreshBoolToggles();
  }

  refreshBoolToggles() {
    this.initialBooleans = [];
    this.initialBooleans = [
      {
        id: 'timingPlanned',
        name: _('lang.globals.planned'),
        value: this.timingPlanned,
        class: 'timingPlanned',
        classPreview: 'blue',
      },
      {
        id: 'timingActive',
        name: _('lang.globals.running'),
        value: this.timingActive,
        class: 'timingActive',
        classPreview: 'green',
      },
      {
        id: 'timingEnded',
        name: _('lang.globals.expired'),
        value: this.timingEnded,
        class: 'timingEnded',
        classPreview: 'grey',
      },
      {
        id: 'timingUnknown',
        name: _('lang.globals.noTiming'),
        value: this.timingUnknown,
        class: 'timingUnknown',
        classPreview: 'grey',
      },
    ];
  }

  buildHoverable(commercials: any) {
    // needs to be any or new commercial interface has to be created / union with hoverable interface
    for (const commercial of commercials) {
      commercial.isHover = false;
    }
    return commercials;
  }

  parseQueryParams() {
    return new Promise(resolve => {
      this.parseBoolQueryParams();
      this.parseDateParams();
      this.parseCullParams().then(() => {
        resolve(true);
      });
    });
  }

  parseDateParams() {
    if (this.queryParamService.getQueryParam('from') && this.queryParamService.getQueryParam('till')) {
      this.from = new SbLocalDateTime(DateTime.fromISO(this.queryParamService.getQueryParam('from')));
      this.till = new SbLocalDateTime(DateTime.fromISO(this.queryParamService.getQueryParam('till')));
    }
  }

  parseCullParams(): Promise<void> {
    return new Promise(res => {
      try {
        const playerCullId = +this.queryParamService.getQueryParam('playerCullSet');
        const geoCullId = +this.queryParamService.getQueryParam('geoCullSet');
        const timeCullId = +this.queryParamService.getQueryParam('timeCullSet');

        let contentCullIds: number[] = [];
        if (this.permissionService.hasPermission(this.permissionService.Permission.cull_list)) {
          contentCullIds = this.filterStorage.get('COMMERCIAL', 'contentCulls') ?? [];
        } else {
          this.filterStorage.clear('COMMERCIAL', 'contentCulls');
        }

        const cullIds: number[] = [playerCullId, geoCullId, timeCullId, ...contentCullIds].filter(Boolean);
        if (cullIds?.length > 0) {
          this.api
            .cs_Cull_retrieveAll({ id: cullIds })
            .pipe(take(1))
            .subscribe({
              next: culls => {
                this.selectedPlayerCull = (culls.find(cull => cull.id === playerCullId) as PlayerCullDTO) ?? null;
                this.selectedTimeCull = (culls.find(cull => cull.id === timeCullId) as TimeCullDTO) ?? null;
                this.selectedGeoCull = (culls.find(cull => cull.id === geoCullId) as GeoCullDTO) ?? null;
                this.selectedContentCulls = culls.filter(cull => contentCullIds.find(contentCullId => cull.id === contentCullId)) ?? [];
                res();
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        } else {
          res();
        }
      } catch (e) {}
    });
  }

  parseBoolQueryParams() {
    const timingPlanned: string = this.queryParamService.getQueryParam('timingPlanned');

    if (timingPlanned === 'true') {
      this.timingPlanned = true;
    } else {
      this.timingPlanned = timingPlanned !== 'false';
    }

    const timingActive: string = this.queryParamService.getQueryParam('timingActive');

    if (timingActive === 'true') {
      this.timingActive = true;
    } else {
      this.timingActive = timingActive !== 'false';
    }

    const timingEnded: string = this.queryParamService.getQueryParam('timingEnded');

    this.timingEnded = timingEnded === 'true';

    const timingUnknown: string = this.queryParamService.getQueryParam('timingUnknown');

    if (timingUnknown === 'true') {
      this.timingUnknown = true;
    } else {
      this.timingUnknown = timingUnknown !== 'false';
    }
  }

  // Modal actions
  selectCommercial(commercial: CommercialWithPreviewReportingDTOAndTags) {
    if (this.isInModalContext) {
      const found = this.util.arrayToIdArray(this.selectedCommercials)?.indexOf(commercial.id);
      if (this.util.arrayToIdArray(this.selectedCommercials) && found !== -1) {
        this.selectedCommercials.splice(found, 1);
      } else {
        this.selectedCommercials.push(commercial);
      }
    }
  }

  returnSelectedCommercials() {
    if (!this.exportState) {
      this.exportState = true;
      this.registerFormChangesListener();
    } else {
      this.exportState = false;
      this.modalNavigation.result({
        commercials: this.selectedCommercials as CommercialDTO[],
        from: this.reportFrom,
        till: this.reportTill,
        name: this.reportName,
      });
      this.reportFrom = null;
      this.reportTill = null;
      this.reportName = null;
    }
  }

  deselectCommercials() {
    this.selectedCommercials = [];
  }

  selectionForExport() {
    const initialCommercials = this.selectedCommercials?.length > 0 ? this.selectedCommercials?.slice() : undefined;
    this.modal
      .showNavigationModal({
        entryComponent: {
          value: CommercialsListComponent,
          data: {
            selectedCommercials: initialCommercials || [],
            modalType: 'commercialSelect',
            campaignId: this.campaignId,
          },
        },
        title: null,
        modalOptions: { windowClass: 'bigXL' },
      })
      .then((result: any) => {
        if (result?.commercials?.length > 0) {
          this.api
            .ds_cm_Campaign_report({
              commercial: this.util.arrayToIdArray(result.commercials),
              from: result.from,
              till: result.till,
              reportName: result.name,
            })
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe((rep: ReportingFullDTO) => {
              this.reportingService.addReport(rep);
              this.modal
                .showNavigationModal({
                  entryComponent: {
                    value: ReportingModalComponent,
                    data: rep,
                  },

                  title: this.translate.instant('lang.globals.download'),
                  modalOptions: { windowClass: 'M' },
                })
                .then(() => {})
                .catch(() => {});
            });
        }
      })
      .catch(() => {});
  }

  private registerFormChangesListener() {
    this.Title.valueChanges.subscribe(value => {
      this.reportName = value;
    });
  }

  localDateTimeInputFrom(date: SbLocalDateTime) {
    this.reportFrom = date;
  }

  localDateTimeInputTill(date: SbLocalDateTime) {
    this.reportTill = date;
  }

  handleDateChange(dates: { fromDate: SbDateTime; toDate: SbDateTime }) {
    this.from = dates?.fromDate ? new SbLocalDateTime(dates.fromDate?.value) : null;
    this.queryParamService.setQueryParam('from', this.from.toString());
    this.till = dates?.toDate ? new SbLocalDateTime(dates.toDate?.value) : null;
    this.queryParamService.setQueryParam('till', this.till.toString());
    this.requestDebounced();
  }

  copyCommercialModal(commercial: CommercialWithPreviewReportingDTOWithHoverAndTags) {
    this.modal
      .confirm({
        title: this.translate.instant('lang.globals.copyCommercial'),
        message: this.translate.instant('lang.globals.copyCommercial.message'),
        yes: this.translate.instant('lang.globals.yes'),
        no: this.translate.instant('lang.globals.no'),
      })
      .then(result => {
        if (result) {
          this.copyCommercial(commercial);
        }
      })
      .catch(() => {});
  }

  private copyCommercial(commercial: CommercialWithPreviewReportingDTOWithHoverAndTags) {
    this.loading = true;
    let copiedCommercial: CommercialFullDTO;
    copiedCommercial = { ...commercial, requirements: [], id: null };
    let pRequirements: RequirementFullDTO[] = [];
    return forkJoin({
      reqs: this.api.ds_cm_Commercial_retrieveRequirements(commercial.id),
      com: this.api.ds_cm_Campaign_createCommercial(this.campaignId, copiedCommercial),
    })
      .pipe(
        switchMap(result => {
          copiedCommercial = result.com;
          pRequirements = result.reqs;
          return from(this.bookingService.createRequirements(copiedCommercial, null, result.reqs));
        }),
        switchMap(createdReq => {
          copiedCommercial.requirements = createdReq;
          return from(this.bookingService.createBookings(createdReq));
        }),
        switchMap((createdBookings: Map<number, BookingDTO[]>) => {
          // check if requirement count from original and copy match
          createdBookings.forEach((bookings, index) => {
            copiedCommercial.requirements[index].bookings = [...bookings];
            // set Media to bookings
            const previewMediaSet: Set<MediumDTO> = new Set();
            pRequirements[index].bookings.forEach(reqBooking => {
              const booking = copiedCommercial.requirements[index].bookings.find(
                lookUpBooking => lookUpBooking.channel?.id === reqBooking.channel?.id
              );
              booking.excluded = reqBooking.excluded;
              if (reqBooking.medium) {
                booking.medium = {
                  ...reqBooking.medium,
                };
                previewMediaSet.add({ ...reqBooking.medium });
              }
            });
            // Mutable cast for editable since previewMedia is readonly
            (copiedCommercial.requirements[index] as Mutable<RequirementFullDTO>).previewMedia = Array.from(previewMediaSet.values());
          });
          const editedBookingPromises = copiedCommercial.requirements.map((requirement: RequirementFullDTO) => {
            return from(this.bookingService.editBookings(requirement.bookings));
          });
          return forkJoin(editedBookingPromises).pipe(
            switchMap(editedBookings => {
              editedBookings.forEach((editBookings, index) => {
                copiedCommercial.requirements[index].bookings = [...editBookings];
              });
              return of(commercial);
            })
          );
        }),
        take(1),
        finalize(() => {
          this.requestDebounced();
        })
      )
      .subscribe({
        next: () => {},
        error: () => {},
      });
  }

  update($event: any, type: string) {
    switch (type) {
      case 'PLAYER_CULLS':
        if ($event && $event?.length > 0) {
          this.selectedPlayerCull = $event[0];
        } else {
          this.selectedPlayerCull = null;
        }
        this.queryParamService.setQueryParam('playerCullSet', this.selectedPlayerCull?.id);
        break;
      case 'GEO_CULLS':
        if ($event && $event?.length > 0) {
          this.selectedGeoCull = $event[0];
        } else {
          this.selectedGeoCull = null;
        }
        this.queryParamService.setQueryParam('geoCullSet', this.selectedGeoCull?.id);
        break;
      case 'TIME_CULLS':
        if ($event && $event?.length > 0) {
          this.selectedTimeCull = $event[0];
        } else {
          this.selectedTimeCull = null;
        }
        this.queryParamService.setQueryParam('timeCullSet', this.selectedTimeCull?.id);
        break;
      case 'CONTENT_CULLS':
        if ($event && $event?.length > 0) {
          this.selectedContentCulls = $event;
          this.filterStorage.set('COMMERCIAL', 'contentCulls', this.util.arrayToIdArray(this.selectedContentCulls));
        } else {
          this.selectedContentCulls = [];
          this.filterStorage.clear('COMMERCIAL', 'contentCulls');
        }
        break;
    }
    this.refreshFromServer().then();
  }

  msRequest(type: string, options?: MsOptions) {
    switch (type) {
      case 'PLAYER_CULLS':
        if (options) {
          this.msPlayerCullOptions = options;
        }
        if (this.msPlayerCullOptions?.pagination) {
          this.api
            .cs_Cull_retrieveAll(
              {
                search: this.util.encodeSearchQueryParam(false, this.msPlayerCullOptions?.search),
                type: 'PlayerCull',
              },
              this.msPlayerCullOptions.pagination
            )
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: (culls: CullDTO[]) => {
                this.playerCulls = culls;
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        }
        break;
      case 'GEO_CULLS':
        if (options) {
          this.msGeoCullOptions = options;
        }
        if (this.msGeoCullOptions?.pagination) {
          this.api
            .cs_Cull_retrieveAll(
              {
                search: this.util.encodeSearchQueryParam(false, this.msGeoCullOptions.search),
                type: 'GeoCull',
              },
              this.msGeoCullOptions.pagination
            )
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: (culls: CullDTO[]) => {
                this.geoCulls = culls;
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        }
        break;
      case 'TIME_CULLS':
        if (options) {
          this.msTimeCullOptions = options;
        }
        if (this.msTimeCullOptions?.pagination) {
          this.api
            .cs_Cull_retrieveAll(
              {
                search: this.util.encodeSearchQueryParam(false, this.msTimeCullOptions.search),
                type: 'TimeCull',
              },
              this.msTimeCullOptions.pagination
            )
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: (culls: CullDTO[]) => {
                this.timeCulls = culls;
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        }
        break;
      case 'CONTENT_CULLS':
        if (options) {
          this.msContentCullOptions = options;
        }
        if (this.msContentCullOptions?.pagination) {
          this.api
            .cs_Cull_retrieveAll(
              {
                search: this.util.encodeSearchQueryParam(false, this.msContentCullOptions.search),
                type: 'ContentCull',
              },
              this.msContentCullOptions.pagination
            )
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: (culls: CullDTO[]) => {
                this.contentCulls = culls;
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        }
        break;
    }
  }
}
